module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.2296967a.svg";